import { FaGithub, FaLinkedin, FaXTwitter, FaYoutube } from 'react-icons/fa6';
import type { IconBaseProps } from 'react-icons';

type BrandIconProps = Omit<IconBaseProps, 'size'> & { size?: number; strokeWidth?: number };

const brandIcon = (Icon: React.ComponentType<IconBaseProps>) =>
  function BrandIcon({ size = 24, strokeWidth: _strokeWidth, ...props }: BrandIconProps) {
    return <Icon size={size} {...props} />;
  };

export const Github = brandIcon(FaGithub);
export const Linkedin = brandIcon(FaLinkedin);
export const Twitter = brandIcon(FaXTwitter);
export const Youtube = brandIcon(FaYoutube);
